const map = require('lodash/fp/map');
const orderBy = require('lodash/fp/orderBy');
const uniqBy = require('lodash/fp/uniqBy');
const flow = require('lodash/fp/flow');
const compose = require('lodash/fp/compose');

export {
    map,
    orderBy,
    uniqBy,
    flow,
    compose,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/lodash/fp.ts